import Section from "@/components/layout/Section";
import Container from "@/components/layout/Container";

export default function PrivacyPolicy() {
  return (
  <>
      <Seo
        title="Privacy Policy | Zenia Stays"
        description="Read the Zenia Stays privacy policy covering data collection, cookies, storage, and user rights."
        canonical="https://zeniastays.com/privacy"
      />
    <Section background="bg-bg-surface" padding="lg">
      <Container>
        <div className="max-w-[900px] mx-auto">

          <h1 className="text-display font-extrabold text-text-primary">
            Privacy Policy
          </h1>

          <p className="mt-3 text-small text-text-muted">
            Effective Date: 15-04-2026
          </p>

          <div className="mt-8 space-y-8 text-body text-text-muted leading-relaxed">

            <p>
              Zenia Stays is committed to protecting your privacy. This policy explains how we collect,
              use, and safeguard your data in compliance with applicable laws including GDPR.
            </p>

            <h2 className="text-title font-semibold text-text-primary">1. Data We Collect</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Name, email, and contact details</li>
              <li>Property data (location, specifications)</li>
              <li>Airbnb or listing URLs</li>
              <li>Device and usage data</li>
            </ul>

            <h2 className="text-title font-semibold text-text-primary">2. How We Use Data</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide property analysis and services</li>
              <li>Improve product performance</li>
              <li>Communicate updates and support</li>
            </ul>

            <h2 className="text-title font-semibold text-text-primary">3. Legal Basis</h2>
            <p>
              We process data based on consent, contractual necessity, and legitimate business interests.
            </p>

            <h2 className="text-title font-semibold text-text-primary">4. Third-Party Services</h2>
            <p>
              We use third-party services including Airbnb, VRBO, Booking.com, Hospitable, and Firebase
              for data storage and processing. These services may process data according to their own policies.
            </p>

            <h2 className="text-title font-semibold text-text-primary">5. Data Storage</h2>
            <p>
              Data is securely stored using cloud infrastructure including Firebase. We implement appropriate
              security measures to protect against unauthorized access.
            </p>

            <h2 className="text-title font-semibold text-text-primary">6. Cookies</h2>
            <p>
              We use cookies for analytics and performance tracking. Users may control cookies via browser settings.
            </p>

            <h2 className="text-title font-semibold text-text-primary">7. Data Retention</h2>
            <p>
              We retain data only as long as necessary for service delivery and legal compliance.
            </p>

            <h2 className="text-title font-semibold text-text-primary">8. User Rights</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Access your data</li>
              <li>Request deletion</li>
              <li>Withdraw consent</li>
              <li>Request correction</li>
            </ul>

            <h2 className="text-title font-semibold text-text-primary">9. Data Security</h2>
            <p>
              We implement technical and organizational safeguards to protect your information.
            </p>

            <h2 className="text-title font-semibold text-text-primary">10. Updates</h2>
            <p>
              This policy may be updated periodically.
            </p>

            <h2 className="text-title font-semibold text-text-primary">11. Contact</h2>
            <p>
              Support: hello@zeniastays.com <br />
              Escalations: operations@zeniastay.com
            </p>

          </div>
        </div>
      </Container>
    </Section>
  </>  
  );
}